var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("headNav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _c("div", { staticClass: "head", class: { unfold: _vm.unfold } }, [
        _c("div", { staticClass: "tit", on: { click: _vm.fold } }, [
          _vm._v(_vm._s(_vm.cur))
        ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.list, function(item) {
            return _c(
              "li",
              {
                key: item.id,
                on: {
                  click: function($event) {
                    return _vm.dtl(item.path)
                  }
                }
              },
              [
                _c(
                  "span",
                  { class: [_vm.tenantClassCur(item), _vm.tenantClass(item)] },
                  [_vm._v(_vm._s(item.val))]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21a88065", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a88065","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/details/index.vue
// module id = null
// module chunks = 